/*
 * PDP urgency counters. Mirrors the drift of the live theme's `useProductUrgency`
 * hook (src/sections/ProductInfo.tsx) so Spark reads the same way:
 *   stock   — every 15s, a 30% chance of selling one, stopping at 3;
 *   viewers — every 5s, a shift of -3..+3, clamped to 8..45.
 * Neither number is inventory data; the row is `aria-hidden` in the markup.
 */
(() => {
  const COUNT = /\{\{\s*count\s*\}\}/g;

  const DRIFTS = [
    {
      selector: '[data-pdp-stock]',
      key: 'pdpStock',
      string: 'stockAvailable',
      every: 15000,
      next: (value) => (value > 3 && Math.random() > 0.7 ? value - 1 : value),
    },
    {
      selector: '[data-pdp-viewers]',
      key: 'pdpViewers',
      string: 'viewersNow',
      every: 5000,
      next: (value) => Math.max(8, Math.min(45, value + Math.floor(Math.random() * 7) - 3)),
    },
  ];

  const timers = new Map();

  // Theme Editor replaces the section's DOM; drop timers for detached nodes.
  const release = () => {
    timers.forEach((id, element) => {
      if (element.isConnected) return;
      clearInterval(id);
      timers.delete(element);
    });
  };

  const attach = (scope) => {
    release();
    DRIFTS.forEach((drift) => {
      scope.querySelectorAll(drift.selector).forEach((element) => {
        if (timers.has(element)) return;
        const template = window.wowthingsStrings?.[drift.string];
        const start = Number(element.dataset[drift.key]);
        if (!template || !Number.isFinite(start)) return;

        timers.set(element, setInterval(() => {
          const current = Number(element.dataset[drift.key]);
          const next = drift.next(current);
          if (next === current) return;
          element.dataset[drift.key] = String(next);
          element.textContent = template.replace(COUNT, next);
        }, drift.every));
      });
    });
  };

  attach(document);
  document.addEventListener('shopify:section:load', (event) => attach(event.target));
})();
